




































































import { Vue, Component } from "vue-property-decorator";
import session from "@/services/SessionService";
import router from "@/router";
import messageService, { Message } from "@/services/MessageService";

@Component
export default class Login extends Vue {
  // Message codes
  static WRONG_PASSWORD = 1;
  static SIGNED_IN = 2;

  // Inputs
  loading: boolean = false;
  submitted: boolean = false;
  email: string = "";
  password: string = "";
  rules = {
    required: (value: string) => !!value || "El campo es requerido",
    min: (value: string) => value.length >= 6 || "Al menos 6 caracteres"
  };

  /**
   * Submits the credentials for authentication
   *
   * @param {string} email
   * @param {string} password
   */
  submit(email: string, password: string) {
    this.submitted = true;
    if (email && password && password.length >= 6) {
      this.loading = true;
      session
        .login({ email, password })
        .then(response => {
          session.securels.set("token", response.data.session.token);
          session.securels.set("user", response.data.session.user);
          session.setUser(response.data.session.user);
          session.setToken(response.data.session.token);
          router.push("/");
          messageService.addMessage({
            id: Login.SIGNED_IN,
            type: "success",
            text: "Bienvenido " + response.data.session.user.full_name,
            overrides: true
          });
        })
        .catch(error => {
          if (error.response.status == 500) {
            messageService.addMessage({
              id: Login.WRONG_PASSWORD,
              type: "error",
              text: "Ha ocurrido un error. Intente más tarde."
            });
          } else {
            messageService.addMessage({
              id: Login.WRONG_PASSWORD,
              type: "warning",
              text:
                "El usuario o la contraseña no son correctos. Intente nuevamente."
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
